module.exports = __webpack_public_path__ + "img/ryzhkov_vasyl.2a3bb56b.png";